import {
  Box,
  Typography,
  List,
  ListItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
} from '@mui/material'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

export default function LoadGroupsList({ loadGroups }) {
  return (
    <Box>
      {loadGroups.map((lg, idx) => (
        <Accordion key={idx} defaultExpanded={false}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">{lg.name}</Typography>
          </AccordionSummary>

          <AccordionDetails>
            <Box width="100%">
              {/* Identifier */}
              <Typography variant="subtitle1" fontWeight="bold">
                Identifier:
              </Typography>
              <Typography variant="body2" mb={2}>
                {lg.identifier}
              </Typography>

              {/* Device Types */}
              <Typography variant="subtitle1" fontWeight="bold">
                Applies to:
              </Typography>
              {lg.deviceTypes.length > 0 ? (
                <List dense>
                  {lg.deviceTypes.map((dt, i) => (
                    <ListItem key={i}>• {dt}</ListItem>
                  ))}
                </List>
              ) : (
                <Typography>No associated device types.</Typography>
              )}

              {/* UX Description */}
              <Box mt={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Customer Description:
                </Typography>
                <Typography variant="body2">{lg.description}</Typography>
              </Box>

              {/* Scope Tags */}
              {lg.scope_tags?.length > 0 && (
                <Box mt={2}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Scope Tags:
                  </Typography>
                  <List dense>
                    {lg.scope_tags.map((tag, i) => (
                      <ListItem key={i}>• {tag}</ListItem>
                    ))}
                  </List>
                </Box>
              )}

              {/* Settings JSON */}
              <Box mt={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Settings:
                </Typography>

                {lg.settings && Object.keys(lg.settings).length > 0 ? (
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, overflowX: 'auto', mt: 1 }}
                  >
                    <pre style={{ margin: 0 }}>
                      {JSON.stringify(lg.settings, null, 2)}
                    </pre>
                  </Paper>
                ) : (
                  <Typography variant="body2">
                    No settings specified.
                  </Typography>
                )}
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  )
}
